
  import {Component, Vue} from 'vue-property-decorator';
  import {
    Action,
    Getter,
  } from 'vuex-class';
  import Card from '@/components/material/Card.vue';
  import DlgHostNew from '@/modules/admin/hosts/_components/DlgHostNew.vue';
  import DlgHostDelete from '@/modules/admin/hosts/_components/DlgHostDelete.vue';
  import DlgHostUpdate from '@/modules/admin/hosts/_components/DlgHostUpdate.vue';

  @Component({
    components: {DlgHostUpdate, DlgHostDelete, DlgHostNew, Card},
  })
  export default class VHosts extends Vue {
    @Action('admin/hosts/read') private read!: () => Promise<void>;
    @Getter('admin/hosts/all') private hosts!: any;

    private headers: any = [
      {
        text: 'Vorname',
        align: 'left',
        value: 'forename',
      },
      {
        text: 'Nachname',
        align: 'left',
        value: 'surname',
      },
      {
        text: 'Email',
        align: 'left',
        value: 'email',
      },
      {
        text: '',
        align: 'left',
        sortable: false,
        value: '',
      },
    ];
    private loading: boolean = false;
    private search: string = '';

    private async mounted() {
      this.loading = true;
      await this.read();
      this.loading = false;
    }
  }
